import { getUserSubscription } from "@api/subscription";
import { RedirectMode } from "@shared/dto/RedirectMode";
import { UserWithSubscriptionRepresentation } from "@shared/dto/UserWithSubscriptionRepresentation";
import { createContext, ReactNode, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTokenContext } from "./UserTokenProvider";

interface UserSubscriptionProvider {
  subscriptionData?: UserWithSubscriptionRepresentation | null;
  setSubscriptionData: (data: UserWithSubscriptionRepresentation) => void;
}

const blankUserSubscription: UserSubscriptionProvider = {
  subscriptionData: null,
  setSubscriptionData: () => {}
};

export const subscriptionContext = createContext<UserSubscriptionProvider>(blankUserSubscription);

export const SubscriptionProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const token = useTokenContext();
  const navigate = useNavigate();
  const [subscriptionData, setSubscriptionData] =
    useState<UserWithSubscriptionRepresentation | null>(null);

  const redirectOrSetData = (data: UserWithSubscriptionRepresentation) => {
    const redirectData = data.redirectMode;
    setSubscriptionData(data);
    if (redirectData) {
      if (redirectData === RedirectMode.Tos) {
        return navigate("/tos");
      }
      if (redirectData === RedirectMode.Payment) {
        return navigate("/payment");
      }
      if (redirectData === RedirectMode.Reactivate) {
        return navigate("/reactivate");
      }
    }
  };

  useEffect(() => {
    if (subscriptionData) {
      redirectOrSetData(subscriptionData);
    } else {
      getUserSubscription().then(data => {
        redirectOrSetData(data);
      });
    }
  }, [subscriptionData, token]);

  return (
    <subscriptionContext.Provider value={{ subscriptionData, setSubscriptionData }}>
      {children}
    </subscriptionContext.Provider>
  );
};

export const useSubscriptionContext = () => {
  return useContext(subscriptionContext);
};
